import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Button, Form, Input, Loader, Segment } from 'semantic-ui-react'
import { UseForm } from '../../Hooks/UseForm'
import { CerrarPopup } from '../../Reducers/PopupReducer';

export const MonitorOrdenesPopup = () => {

    const dispatch = useDispatch();
    const { Entidad, OnChange, SetEntidad } = UseForm()
    useEffect(() => { Load(); }, [])

    const Load = async () => {
        SetEntidad({
            PorCompra: 5,
            PorVenta: 5,
        })
    }
    const OnClickMonitoriar = async () => {
        dispatch(CerrarPopup(Entidad));
    }

    return (<>
        <Segment>
            <Form>
                <Form.Field>
                    <label>Porcentaje de Compra</label>
                    <Input name="PorCompra" onChange={OnChange} value={Entidad.PorCompra} placeholder='% de Compra' type="number" />
                </Form.Field>
                <Form.Field>
                    <label>Porcentaje de Venta</label>
                    <Input name="PorVenta" onChange={OnChange} value={Entidad.PorVenta} placeholder='% de Venta' type="number" />
                </Form.Field>
                <Button onClick={OnClickMonitoriar} >Monitoriar</Button>
            </Form>
        </Segment>
    </>)
}
